export default "__VITE_ASSET__B$uikAnr__"